import { FC, MouseEvent } from 'react';

import Link from 'next/link';
import { useRouter } from 'next/router';

import { useClearDispatch } from '@contexts/auth/AuthContext';
import { removeBasketDetailsOnLocalStorage } from '@utils/removeBasketDetailsOnLocalStorage';
import { callService } from '@api/caller';
import { removeCsoLoginParamsOnLocalStorage } from '@utils/removeCsoLoginParamsOnLocalStorage';

import { StyledLink } from './styled';

interface IUserMenuLink {
  label: string;
  href: string;
}

const UserMenuLink: FC<IUserMenuLink> = ({ label, href }) => {
  const router = useRouter();

  const clearUserInformation = useClearDispatch();

  const handleClick = async (e: MouseEvent<HTMLAnchorElement>) => {
    if (href === '/logout') {
      e.preventDefault();

      /**
       * Call logout service
       */
      try {
        await callService('AuthenticationService', 'logout');
      } catch (error) {
        console.error(error);
      }

      /**
       * Clear user information from context
       */
      clearUserInformation();

      /**
       * Remove basket details from local storage when user logs out
       */
      removeBasketDetailsOnLocalStorage();

      /**
       * Remove cso login params from local storage when user logs out
       */
      removeCsoLoginParamsOnLocalStorage();

      /**
       * Redirect to home page
       */
      router.push('/');
      return false;
    }

    return true;
  };

  return (
    <Link href={href} passHref legacyBehavior>
      <StyledLink onClick={handleClick}>{label}</StyledLink>
    </Link>
  );
};

export default UserMenuLink;
